import * as React from "react";
import { FormGroup, FormControl, ControlLabel, Button, Checkbox } from "react-bootstrap"

import { BaseComponent } from "./BaseComponent"
import { hideModal } from "./popups"

export interface IBaseFormModel<TModel> {
    model: TModel;
    errors: { [field: string]: "success" | "warning" | "error" };
    errorMessage: string | null;
    disabled: boolean;
}

export class BaseFormComponent<TModel> extends BaseComponent<TModel, IBaseFormModel<TModel>> {
    constructor(props: TModel) {
        super(props);
        this.state = {
            model: Object.assign({}, props),
            errors: {},
            errorMessage: null,
            disabled: false
        };
    }
    protected isDisabled(field: keyof TModel) {
        return this.state.disabled;
    }
    protected field(label: string, field: keyof TModel, type: string = "text"): any {
        const checkbox = type === "checkbox";
        return <FormGroup
            controlId={field.toString()}
            validationState={this.state.errors[field]}
            >
            {checkbox
                ? <Checkbox
                    readOnly={this.isDisabled(field)}
                    defaultChecked={ this.getModelField(field) }
                    onChange={(e: any) => this.setModelField(field, e.target.checked) }>{label}</Checkbox>
                : <ControlLabel>{label}</ControlLabel>
            }
            {checkbox ? null :
                    <FormControl
                    readOnly={this.isDisabled(field) }
                    type={type}
                    defaultValue={this.getModelField(field)}
                    onChange={(e: any) =>  this.setModelField(field, e.target.value) }
                />}
            <FormControl.Feedback />
        </FormGroup>;
    }

    protected button(
        label: string,
        type: "button" | "reset" | "submit",
        action?: (consumer: (errorMessage: string | null) => void) => void,
        bsStyle?: string,
        validate: boolean = (type === "submit")) {
        return <Button key={label} onClick={() => {
                      if (!validate || this.validate(false)) {
                          if (action) {
                              this.setState({ disabled: true } as any);
                              action((errorMessage: string) => this.handleError(errorMessage));
                          } else {
                              hideModal();
                          }
                      }
                } } bsStyle={bsStyle} disabled={this.state.disabled} type={type}>{label}</Button>;
    }
    protected link(label: string, action: () => void) {
        return <a href="#" onClick={(e: React.MouseEvent<{}>) => {
                    if (!this.state.disabled) {
                        action();
                    }
                    e.preventDefault();
        } }>{ label }</a >;
    }
    private handleError(errorMessage: string) {
        if (errorMessage) {
            this.setState({ errorMessage: errorMessage, disabled: false } as any);
        } else {
            hideModal();
        }
    }
    protected getModelField(field: keyof TModel): any {
        return (this.state.model as any)[field];
    }
    protected setModelField(field: keyof TModel, value: any) {
        const model = Object.assign({}, this.state.model) as any;
        model[field] = value;
        this.setState({ model: model } as any);
        if(this.state.errors[field.toString()]) {
            this.validateInternal(it => model[it], true);
        }
    }
    protected requiredFields(): (string | null)[] { return []; }
    protected validate(updateErrorMessage: boolean = true) {
        return this.validateInternal((field: keyof TModel) => this.getModelField(field), updateErrorMessage);
    }
    private validateInternal(valueGetter: (field: keyof TModel) => any, updateErrorMessage: boolean) {
        let missing = false;
        let usernameError: string | null = null;
        const errors: { [field: string]: "success" | "warning" | "error" } = {};
        this.requiredFields().forEach((field: string | null) => {
            if (field) {
                const fieldAsString = `${field}`;
                const value = valueGetter(field as keyof TModel);
                if (!value) {
                    errors[fieldAsString] = "error";
                    missing = true;
                } else if((field === "Username") && (!this.isValidEmail(value))) {
                    errors[fieldAsString] = "error";
                    usernameError = "Vennligst fyll inn en gyldig e-postadresse";
                }
            }
        });
        const missingError = missing ? "Vennligst fyll ut de merkede feltene" : usernameError;
        const extraError = missingError || this.extraValidation();
        const errorMessage = extraError || (updateErrorMessage ? null : this.state.errorMessage);
        this.setState({ errors: errors, errorMessage: errorMessage } as any);
        return !extraError;
    }
    private isValidEmail(value: string) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(value);
    }

    // Override with extra error message
    protected extraValidation(): string | null { return null; }
}


// WEBPACK FOOTER //
// ./Scripts/React/Component/BaseFormComponent.tsx